import Query from '../../../components/Report';

export const query = ({ offset = 0, cluster }) =>
    new Query('search-keywords-clusters-urls-detail-table', {
        offset,
        cluster,
    });
